import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilterMetadata, MessageService, SortMeta } from 'primeng/api';
import { Table } from 'primeng/table';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { FieldDivisionGroupsService } from 'src/app/services/fd-groups.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { AppUtils } from 'src/app/shared/app.utils';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'ness-manage-elasticsearch',
  templateUrl: './manage-elasticsearch.component.html'
})
export class ManageElasticSearchComponent {
  loading: boolean = false;
  AppUtils = AppUtils;
  checkIdxAdr: boolean = false;
  checkIdxCgc: boolean = false;
  showConfirmDialog: boolean = false;
  buttonMode: number = 0;
  cgids: string = '';
  rmsids: string = '';
  agencyOri: string = '';
  beMinutes: string = '';

  private _destroyed$: Subject<void> = new Subject<void>();

  constructor(private adminService: AdminService,
    private messageService: MessageService) { }

  public onMessageClose(evt: Event): void {
    evt.stopPropagation();
  }

  reindexStart(): void {
    console.log('reindex launched');
    this.messageService.add({ key:'reindexSuccessMsg', severity: 'success', summary: 'Success:', detail: `ElasticSearch reindexing has started.`, life:5000 });
  }

  reindexFailed(err: any): void {
    console.log('reindex failed');
    console.log(err);
    // this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error || err.error.ExceptionMessage || err.error.Message || err.message || 'An error occurred starting ElasticSearch reindex.' });
  }

  showConfirmDialogClicked(bmode: number) {
    this.buttonMode = bmode;
    this.showConfirmDialog = true;
  }

  confirmDialogResponseClicked(confirm: boolean) {
    if (confirm) {
      if (this.buttonMode == 1) this.reindexLast48();
      else if (this.buttonMode == 2) this.reindexAll();
    }
    this.buttonMode = 0;
    this.showConfirmDialog = false;
  }

  isIdxChecked() {
    return this.getIdxString().length > 10;
  }

  getIdxString() {
    let r = '?days=2';
    if (this.checkIdxAdr) r += '&index=adr';
    if (this.checkIdxCgc) r += '&index=cgc';
    return r;
  }

  public reindexAll(): void {
    this.adminService.elasticSearchReindexAll(this.getIdxString()).pipe(takeUntil(this._destroyed$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.reindexStart();

      },
      (err: any) => {
        this.loading = false;
        this.reindexFailed(err);
      }
    );
  }

  public reindexLast48(): void {
    this.adminService.elasticSearchReindexRecent(this.getIdxString()).pipe(takeUntil(this._destroyed$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.reindexStart();
      },
      (err: any) => {
        this.loading = false;
        this.reindexFailed(err);
      }
    );
  }

  public reindexByCGID(): void {
    let p = '?q=1';
    this.cgids.split(",").forEach(function (cgid) {
      p += '&cgid=' + cgid;
    });
    this.adminService.elasticSearchReindexByCGID(p).pipe(takeUntil(this._destroyed$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.cgids = '';
        this.reindexStart();
      },
      (err: any) => {
        this.loading = false;
        this.reindexFailed(err);
      }
    );
  }

  public reindexByRMSID(): void {
    let p = '?q=1';
    this.rmsids.split(",").forEach(function (cgid) {
      p += '&rmsid=' + cgid;
    });
    this.adminService.elasticSearchReindexByRMSID(p).pipe(takeUntil(this._destroyed$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.rmsids = '';
        this.reindexStart();
      },
      (err:any) => {
        this.loading = false;
        this.reindexFailed(err);
      }
    );
  }

  public reindexByAgencyORI(): void {
    let p = '?ori=' + this.agencyOri;
    this.adminService.elasticSearchReindexByAgencyORI(p).pipe(takeUntil(this._destroyed$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.agencyOri = '';
        this.reindexStart();
      },
      (err: any) => {
        this.loading = false;
        this.reindexFailed(err);
      }
    );
  }

  public reindexBallisticEvidence(): void {
    let p = '?minutes=' + this.beMinutes;
    this.adminService.elasticSearchReindexBallisticEvidence(p).pipe(takeUntil(this._destroyed$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.beMinutes = '';
        this.reindexStart();
      },
      (err: any) => {
        this.loading = false;
        this.reindexFailed(err);
      }
    );
  }
}
